var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"size":"sm","variant":"outline-primary"},on:{"click":_vm.handleClick}},[_vm._v("Back")])
}
var staticRenderFns = []

export { render, staticRenderFns }